import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/home/runner/work/ubt/ubt/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js')["default"];

var scope_1 = require('/home/runner/work/ubt/ubt/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/64ac5a90234dc032ac633e3fe4666f66.js')["default"];

export default Object.assign({}, scope_0, scope_1);